var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"collapse-container",class:[
        'collapse-container',
        _vm.pageLang,
        {
            pc: _vm.isPc
        }
    ]},[_c('div',{staticClass:"collapse-panel",style:([_vm.cssPropertys])},[_c('section',{class:[
                'panel-body',
                {
                    'full-height': !_vm.isCollapsed
                }
            ]},[_c('free-container',{attrs:{"children":_vm.tpl.children}})],1),_vm._v(" "),_c('button',{class:['collapse-btn', _vm.btnPosition],on:{"click":_vm.toggleCollapse}},[(_vm.showText)?_c('p',{staticClass:"collapse-text",domProps:{"innerHTML":_vm._s(_vm.btnText)}}):_vm._e(),_vm._v(" "),_c('Icon',{staticClass:"collapse-icon",attrs:{"isActive":!_vm.isCollapsed,"iconColor":_vm.iconColor}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }